import Swiper from 'swiper/bundle';

const FeaturedPrograms = () => {
    console.log('helloaefaef');
    const sliders = document.querySelectorAll('.featured-programs__swiper');
    if (!sliders.length) return;

    const swiperInstances = new WeakMap();

    const initOrDestroySwiper = () => {
        sliders.forEach((slider) => {
            if (!(slider instanceof Element)) return;

            const slides = slider.querySelectorAll('.swiper-slide');
            const totalSlides = slides.length;

            const existingSwiper = swiperInstances.get(slider);

            const isTabletUp = window.innerWidth >= 577;

            const shouldInitSwiper =
            totalSlides > 2 || (totalSlides === 2 && !isTabletUp);

            if (!shouldInitSwiper) {
            if (existingSwiper) {
                existingSwiper.destroy(true, true);
                swiperInstances.delete(slider);
            }
            return;
            }

            if (!existingSwiper) {
            const swiper = new Swiper(slider, {
                slidesPerView: 1.1,
                spaceBetween: 0,
                loop: true,
                pagination: {
                el: slider.querySelector('.featured-programs__pagination'),
                clickable: true,
                },
                navigation: {
                nextEl: slider.querySelector('.featured-programs__nav--next'),
                prevEl: slider.querySelector('.featured-programs__nav--prev'),
                },
                breakpoints: {
                577: {
                    slidesPerView: 2,
                },
                },
            });

            swiperInstances.set(slider, swiper);
            }
        });
    };

    // Initial load
    initOrDestroySwiper();

    // Responsive check
    window.addEventListener('resize', () => {
        initOrDestroySwiper();
    });
};

export default FeaturedPrograms;
